export function AviationBackground() {
  return (
    <div className="aviation-bg fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {/* Warm ambient glow */}
      <div className="absolute top-[-10%] right-[10%] w-[900px] h-[600px] rounded-full bg-[#C5A059]/[0.02] blur-[150px]" />
      <div className="absolute bottom-[10%] left-[-5%] w-[700px] h-[500px] rounded-full bg-[#C5A059]/[0.015] blur-[120px]" />

      {/* Cloud 1 - large, high, slow */}
      <div className="av-cloud-drift absolute top-[6%] left-[-25%] w-[700px] h-[200px]" style={{ animationDuration: '130s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.02] to-transparent rounded-full blur-[50px]" />
        <div className="absolute top-[15%] left-[10%] w-[80%] h-[70%] bg-gradient-to-r from-transparent via-white/[0.028] to-transparent rounded-full blur-[60px]" />
        <div className="absolute top-[30%] left-[25%] w-[50%] h-[50%] bg-gradient-to-r from-transparent via-white/[0.02] to-transparent rounded-full blur-[40px]" />
      </div>

      {/* Cloud 2 - mid height */}
      <div className="av-cloud-drift absolute top-[28%] left-[-30%] w-[550px] h-[160px]" style={{ animationDuration: '105s', animationDelay: '-45s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.018] to-transparent rounded-full blur-[45px]" />
        <div className="absolute top-[20%] left-[15%] w-[70%] h-[60%] bg-gradient-to-r from-transparent via-white/[0.024] to-transparent rounded-full blur-[55px]" />
      </div>

      {/* Cloud 3 - wide, lower */}
      <div className="av-cloud-drift absolute top-[50%] left-[-20%] w-[800px] h-[180px]" style={{ animationDuration: '150s', animationDelay: '-70s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.015] to-transparent rounded-full blur-[55px]" />
        <div className="absolute top-[25%] left-[20%] w-[60%] h-[55%] bg-gradient-to-r from-transparent via-white/[0.022] to-transparent rounded-full blur-[50px]" />
        <div className="absolute top-[10%] left-[40%] w-[35%] h-[60%] bg-gradient-to-r from-transparent via-white/[0.018] to-transparent rounded-full blur-[45px]" />
      </div>

      {/* Cloud 4 - small wispy, warm tint */}
      <div className="av-cloud-drift absolute top-[18%] left-[-15%] w-[400px] h-[110px]" style={{ animationDuration: '95s', animationDelay: '-25s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#C5A059]/[0.018] to-transparent rounded-full blur-[35px]" />
        <div className="absolute top-[20%] left-[25%] w-[55%] h-[60%] bg-gradient-to-r from-transparent via-[#C5A059]/[0.014] to-transparent rounded-full blur-[40px]" />
      </div>

      {/* Cloud 5 - low */}
      <div className="av-cloud-drift absolute top-[70%] left-[-25%] w-[600px] h-[150px]" style={{ animationDuration: '115s', animationDelay: '-55s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.016] to-transparent rounded-full blur-[45px]" />
        <div className="absolute top-[20%] left-[15%] w-[65%] h-[55%] bg-gradient-to-r from-transparent via-white/[0.022] to-transparent rounded-full blur-[50px]" />
      </div>

      {/* Cloud 6 - very high, thin */}
      <div className="av-cloud-drift absolute top-[3%] left-[-20%] w-[500px] h-[80px]" style={{ animationDuration: '160s', animationDelay: '-90s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.012] to-transparent rounded-full blur-[30px]" />
      </div>

      {/* Cloud 7 - mid, warm golden haze */}
      <div className="av-cloud-drift absolute top-[40%] left-[-18%] w-[450px] h-[130px]" style={{ animationDuration: '125s', animationDelay: '-100s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#C5A059]/[0.015] to-transparent rounded-full blur-[40px]" />
        <div className="absolute top-[25%] left-[20%] w-[60%] h-[50%] bg-gradient-to-r from-transparent via-[#C5A059]/[0.012] to-transparent rounded-full blur-[45px]" />
      </div>

      {/* Cloud 8 - near bottom */}
      <div className="av-cloud-drift absolute top-[85%] left-[-22%] w-[650px] h-[140px]" style={{ animationDuration: '140s', animationDelay: '-35s' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.014] to-transparent rounded-full blur-[50px]" />
        <div className="absolute top-[15%] left-[30%] w-[45%] h-[65%] bg-gradient-to-r from-transparent via-white/[0.019] to-transparent rounded-full blur-[45px]" />
      </div>
    </div>
  );
}
